export default __webpack_public_path__ + "static/media/pogot-screenshot-03.7e120821.png";